import React, { useEffect, useState } from "react";
import copy from "copy-to-clipboard";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import requiredImg from "../../../Images/sp.gif";
import TrainingLink from "./TrainingLink";
import { CLIENT_SEARCH_FILTERS } from "../../../constants/clientSearchFilters";
import { keyRestrict } from "../../../utils/array";
import { DisplayMsg } from "../../../services/toastService";
import { setTrainingEvents } from "../../../store/reducers/SharedLayoutDataSlice";
import { EMAIL_REGEX } from "../../../constants/regex";
import { setUrl } from "../../../handlers";

const NewPlan = (props) => {
  const dispatch = useDispatch();
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [Errors, setErrors] = useState({
    TrainingType: "",
    Invitee: "",
    Email: "",
    TrainerEmail: "",
    Hours: "",
    ProjectType: "",
  });
  const [TrainingDetail, setTrainingDetail] = useState({
    TrainingType: "CLINICAL",
    Description: "",
    Invitee: "",
    Email: "",
    TrainerEmail: "",
    TrainerId: "",
    ProjectType: "1",
    Hours: "",
    DateTime: null,
    ScheduleLink: "",
    VideoLink: "",
    status: "INPROCESS",
    Comments: "",
    TrainerEvents: [{ label: "-Select", value: "" }],
  });
  const [AddTraining, setAddTraining] = useState(false);

  let check = true;

  const PlanPopup = () => {
    props.parentCallback(false, null);
  };

  useEffect(() => {
    const data = props.trainingData;

    if (data != null) {
      if (data?.SEQ_NUM != null) {
        const data = props.trainingData;

        setTrainingDetail((trainingData) => ({
          ...trainingData,
          TrainingType: data.TRAINING_TYPE,
          Description: data.TRAINING_DESCRIPTION,
          Invitee: data.INVITEE,
          Email: data.INVITEE_EMAIL,
          TrainerEmail: data.TRAINNER,
          ProjectType: data.PROJECT_TYPE_SEQ_NUM,
          Hours: data.TOTAL_HOURS,
          DateTime:
            data.SCHEDULE_DATETIME !== "" ? new Date(data.SCHEDULE_DATETIME) : "",
          ScheduleLink: data.TRAINING_SCHEDULE_LINK,
          VideoLink: data.TRAINING_VIDEO_LINK,
          Comments: data.TRAINING_COMMENTS,
          status: data.TRAINING_STATUS,
        }));

        if (data.TRAINNER != null && data.TRAINING_SCHEDULE_LINK === "") {
          const currentTrainer = props.trainersTypes?.find((obj) => obj.EMAIL === data.TRAINNER);

          if (currentTrainer && currentTrainer.UUID) {
            FetchEvents(currentTrainer);
            setTrainingDetail((trainingData) => ({
              ...trainingData,
              TrainerId: currentTrainer.UUID,
            }));
          }
        }
      }
      if (data.SEQ_NUM == null) {
        if (props.trainersTypes && props.trainersTypes.length > 0) {
          const data = props.trainersTypes;
          setTrainingDetail((trainingData) => ({
            ...trainingData,
            TrainerEmail: data[0].EMAIL,
            TrainerId: data[0].UUID,
          }));
        }
      }
    }

  }, []);

  const AddNewTraining = async (e, type) => {
    if (type === "DateTime") {
      const dateVal = e;
      if (e != null) {
        setTrainingDetail((trainingData) => ({
          ...trainingData,
          DateTime: dateVal,
        }));
      } else {
        setTrainingDetail((trainingData) => ({
          ...trainingData,
          DateTime: null,
        }));
      }
    } else if (type === "trainerEmail") {
      let TrainerData;
      if (e.target.value !== "-Select-") {
        TrainerData = props.trainersTypes.find((obj) => obj.EMAIL === e.target.value);
      } else {
        const data = {
          EMAIL: "-Select-",
          UUID: null,
        };
        TrainerData = data;
      }

      setTrainingDetail((trainingData) => ({
        ...trainingData,
        TrainerEmail: TrainerData.EMAIL,
        TrainerId: TrainerData.UUID,
      }));

      setErrors((errorInfo) => ({
        ...errorInfo,
        [e.target.name]:
          TrainerData.EMAIL !== "-Select-" || TrainerData.EMAIL == null
            ? ""
            : "Required",
      }));

      if (TrainerData.UUID != null) {
        FetchEvents(TrainerData);
      }
    } else if (e.target.name === "Hours") {
      const re = /^\d{1,2}$|(?=^.{1,5}$)^\d+\.\d{0,1}$/;
      if (e.target.value !== "") {
        if (e.target.value === 0) {
          setErrors((errorInfo) => ({
            ...errorInfo,
            [e.target.name]: "Hours value must be greater then 0",
          }));
        }
        if (re.test(e.target.value)) {
          setTrainingDetail((trainingData) => ({
            ...trainingData,
            [e.target.name]: e.target.value,
          }));
          if (e.target.value !== 0) {
            setErrors((errorInfo) => ({
              ...errorInfo,
              [e.target.name]: e.target.value.length > 0 ? "" : "Required",
            }));
          }
        }
      } else {
        setTrainingDetail((trainingData) => ({
          ...trainingData,
          [e.target.name]: e.target.value,
        }));

        setErrors((errorInfo) => ({
          ...errorInfo,
          [e.target.name]: e.target.value.length > 1 ? "" : "Required",
        }));
      }
    } else if (type === "Invitee") {
      const AlphabetRegex = /^[a-zA-Z0-9_ ]*$/;
      if (AlphabetRegex.test(e.target.value) || e.target.value === "") {
        setTrainingDetail((trainingData) => ({
          ...trainingData,
          [e.target.name]: e.target.value,
        }));

        setErrors((errorInfo) => ({
          ...errorInfo,
          [e.target.name]: e.target.value.length > 0 ? "" : "Required",
        }));
      }
    } else {
      const { name } = e.target;
      const { value } = e.target;

      ValidateField(name, value);
      setTrainingDetail((trainingData) => ({
        ...trainingData,
        [name]: value,
      }));
    }
  };

  const FetchEvents = async (TrainerData) => {
    const EventsArray = [];

    const filter = `&active=true` + `&uuid=${TrainerData.UUID}`;
    await fetch(setUrl("calendly", "event", true) + filter)
      .then((response) => response.json())
      .then((json) => {
        if (json.status === true) {
          if (json.responseContent != null) {
            const item = {
              label: "-Select-",
              value: "",
            };
            EventsArray.push(item);
            json.responseContent.forEach((item) => {
              const eventDetail = {
                label: item,
                value: item,
              };
              EventsArray.push(eventDetail);
            });

            dispatch(setTrainingEvents(EventsArray));

            setTrainingDetail((trainingData) => ({
              ...trainingData,
              TrainerEvents: json.responseContent,
            }));
          }
        } else {
          DisplayMsg("2", json.Message);
        }
      })
      .catch((error) => {
        DisplayMsg("2", "Failed to load trainer");
      });
  };

  const ValidateField = (fieldName, fieldVal) => {
    if (fieldVal.length < 1) {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: "Required",
      }));
    } else if (fieldName === "Email") {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: EMAIL_REGEX.test(fieldVal) ? "" : "❌ Email is not valid!",
      }));
    } else {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: "",
      }));
      check = true;
    }
  };

  const VerifyFields = () => {
    for (const plan in TrainingDetail) {
      if (plan !== "DateTime") {
        if (plan !== "TrainerId") {
          if (
            TrainingDetail[plan].length < 1 &&
            plan !== "Description" &&
            plan !== "Comments" &&
            plan !== "ScheduleLink" &&
            plan !== "VideoLink" &&
            plan !== "DateTime" &&
            plan !== "TrainerId" &&
            plan !== "Invitee"
          ) {
            setErrors((errorInfo) => ({
              ...errorInfo,
              [plan]: "Required",
            }));
            check = false;
          } else if (plan === "Email") {
            let result = "";
            if (EMAIL_REGEX.test(TrainingDetail.Email)) {
              result = "";
              // check = true;
            } else {
              result = "❌ Email is not valid!";
              check = false;
            }
            setErrors((errorInfo) => ({
              ...errorInfo,
              Email: result,
            }));
          } else if (TrainingDetail[plan] === "-Select-") {
            setErrors((errorInfo) => ({
              ...errorInfo,
              [plan]: "Required",
            }));
          } else if (plan === "Invitee") {
            if (TrainingDetail[plan] === "") {
              setErrors((errorInfo) => ({
                ...errorInfo,
                [plan]: "Required",
              }));
              check = false;
            }
          } else if (plan === "Hours") {
            if (TrainingDetail[plan] === 0 || TrainingDetail[plan] === "") {
              setErrors((errorInfo) => ({
                ...errorInfo,
                [plan]: "Hours value must be greater then 0",
              }));
              check = false;
            }
          } else {
            setErrors((errorInfo) => ({
              ...errorInfo,
              [plan]: "",
            }));
          }
        }
      }
    }
  };

  const CreateTraining = async () => {
    VerifyFields();

    const training = props.trainingData;

    if (check) {
      const jsonData = {
        AUTH_ENTITY_SEQ_NUM:
          training?.AUTH_ENTITY_SEQ_NUM == null
            ? sharedData.currentClientId
            : training?.AUTH_ENTITY_SEQ_NUM,
        TRAINING_DESCRIPTION: TrainingDetail.Description,
        TRAINING_TYPE: TrainingDetail.TrainingType,
        TRAINING_CONDUCTED_BY: TrainingDetail.TrainerEmail,
        SCHEDULE_DATETIME:
          TrainingDetail.DateTime != null
            ? TrainingDetail.DateTime.toLocaleString()
            : "",
        TRAINING_VIDEO_LINK: TrainingDetail.VideoLink,
        TRAINING_SCHEDULE_LINK: TrainingDetail.ScheduleLink,
        TOTAL_HOURS: TrainingDetail.Hours,
        TRAINING_STATUS: TrainingDetail.status,
        INVITEE: TrainingDetail.Invitee,
        INVITEE_EMAIL: TrainingDetail.Email,
        TRAINING_COMMENTS: TrainingDetail.Comments,
        TRAINNER: TrainingDetail.TrainerEmail,
        PROJECT_TYPE_SEQ_NUM: parseInt(TrainingDetail.ProjectType),
        SEQ_NUM: training?.SEQ_NUM,
      };

      const trainingInfo = JSON.stringify(jsonData);
      try {
        const formData = new FormData();
        formData.append("TrainingData", trainingInfo);
        document.getElementById("loader").style.display = "block";

        // .AUTH_ENTITY_SEQ_NUM

        const action =
          props.trainingData?.SEQ_NUM != null ? "UPDATETRINING" : "ADDTRINING";
        const response = await fetch(setUrl("CLIENTDETAIL", action, true), {
          method: "POST",
          body: formData,
        });
        const json = await response.json();
        if (json && json.status) {
          DisplayMsg("1", json.Message);
          props.parentCallback(false, TrainingDetail);
        } else {
          DisplayMsg("2", json.Message);
        }
      } catch (e) {
        DisplayMsg("2", "Unable to Process the Request");
      }
    }
  };

  const GenerateLink = (event) => {
    VerifyTrainingField();
    if (check) {
      if (event.target.value === "Copy") {
        copy(TrainingDetail.ScheduleLink);
      } else {
        setAddTraining(true);
      }
    }
  };

  const VerifyTrainingField = () => {
    let result = "";
    for (const plan in TrainingDetail) {
      if (plan === "Invitee" || plan === "Email") {
        if (TrainingDetail[plan].length < 1) {
          setErrors((errorInfo) => ({
            ...errorInfo,
            [plan]: "Required",
          }));
          check = false;
        } else if (plan === "Email") {
          if (TrainingDetail[plan].length < 1) {
            setErrors((errorInfo) => ({
              ...errorInfo,
              [plan]: "Required",
            }));
            check = false;
          } else if (EMAIL_REGEX.test(TrainingDetail.Email)) {
            result = "";
          } else {
            result = "❌ Email is not valid!";
            check = false;
          }
          setErrors((errorInfo) => ({
            ...errorInfo,
            Email: result,
          }));
        }
      } else if (plan === "TrainerEmail") {
        if (
          TrainingDetail[plan] === "-Select-" ||
          TrainingDetail[plan] === ""
        ) {
          setErrors((errorInfo) => ({
            ...errorInfo,
            [plan]: "Required",
          }));
          check = false;
        }
      }
    }
  };

  const HandleSetTraining = (childData, link) => {
    setTrainingDetail((trainingData) => ({
      ...trainingData,
      ScheduleLink: link,
    }));
    setAddTraining(childData);
  };

  const AlterDateValues = (e) => {
    keyRestrict(e, "0123456789");
    if (e.target.value.length <= 10) {
      setTrainingDetail((dateInfo) => ({
        ...dateInfo,
        [e.target.name]: e.target.value,
      }));
    }
  };

  return (
    <>
      {AddTraining && (
        <TrainingLink
          CallBackLink={HandleSetTraining}
          data={{
            InviteeEmail: TrainingDetail.Email,
            Trainer: TrainingDetail.TrainerEmail,
            TrainerUuid: TrainingDetail.TrainerId,
            Events: sharedData.trainingEvents,
            Invitee: TrainingDetail.Invitee,
          }}
        />
      )}

      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />

      <div
        className={`overlay ${AddTraining === true ? "d-none" : "-webkit-inline-box"
          }`}
      >
        <div className="popup">
          <div className="popup__header">
            <h3>
              {props.trainingData?.SEQ_NUM != null
                ? "Update Training"
                : "Add Training"}{" "}
            </h3>
            <span
              className="close"
              role="button"
              onClick={() => PlanPopup(false)}
            >
              ×
            </span>
          </div>
          <div className="content">
            <div className="popup__body">
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Type{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        width={2}
                        className="redboxRequired"
                      />{" "}
                    </label>
                    <select
                      className="field-input"
                      name="TrainingType"
                      onChange={(e) => AddNewTraining(e)}
                      value={TrainingDetail.TrainingType}
                    >
                      {props?.trainingTypes.map((item) => (
                        <option value={item.TRAINING_TYPE}>
                          {item.TRAINING_TYPE}
                        </option>
                      ))}
                    </select>
                  </div>
                  <label className="requiredtext mt-0">
                    {Errors.TrainingType}
                  </label>
                </div>

                <div className="col-md-6 col-sm-6">
                  <div className="field-container">
                    <label className="field-placeholder font-medium">
                      Description :
                    </label>
                    <input
                      type="text"
                      name="Description"
                      className="field-input"
                      onChange={(e) => AddNewTraining(e)}
                      value={TrainingDetail.Description}
                      maxLength={4000}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Invitee :{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        width={4}
                        className="redboxRequired"
                      />
                    </label>
                    <input
                      type="text"
                      name="Invitee"
                      className="field-input"
                      onChange={(e) => AddNewTraining(e, "Invitee")}
                      value={TrainingDetail.Invitee}
                      maxLength={55}
                    />
                  </div>
                  <label className="requiredtext mt-0">{Errors.Invitee}</label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Invitee Email :{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />
                    </label>
                    <input
                      type="text"
                      name="Email"
                      className="field-input"
                      onChange={(e) => AddNewTraining(e)}
                      value={TrainingDetail.Email}
                      maxLength={55}
                    />
                  </div>
                  <label className="requiredtext mt-0">{Errors.Email}</label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Trainer :{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />
                    </label>
                    <select
                      className="field-input"
                      name="TrainerEmail"
                      onChange={(e) => AddNewTraining(e, "trainerEmail")}
                      value={TrainingDetail.TrainerEmail}
                      disabled={
                        TrainingDetail.ScheduleLink.length > 1
                      }
                    >
                      {props.trainersTypes &&
                        props.trainersTypes.map((item) => (
                          <option value={item.EMAIL}>{item.EMAIL}</option>
                        ))}
                    </select>
                  </div>
                  <label className="requiredtext mt-0">
                    {Errors.TrainerEmail}
                  </label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Project Type:{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />
                    </label>
                    <select
                      className="field-input"
                      name="ProjectType"
                      value={TrainingDetail.ProjectType}
                      onChange={(e) => AddNewTraining(e)}
                    >
                      {props?.projectTypes.map((item) => (
                        <option value={item.SEQ_NUM}>
                          {item.PROJECT_TYPE}
                        </option>
                      ))}
                    </select>
                  </div>
                  <label className="requiredtext mt-0">
                    {Errors.ProjectType}
                  </label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Total Hours:{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />
                    </label>
                    <input
                      type="text"
                      onChange={(e) => AddNewTraining(e)}
                      name="Hours"
                      className="field-input"
                      value={TrainingDetail.Hours}
                    />
                  </div>
                  <label className="requiredtext mt-0">{Errors.Hours}</label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container overflow-visible">
                    <label className="field-placeholder font-medium">
                      Schedule Date Time:
                    </label>
                    <DatePicker
                      value={
                        TrainingDetail.DateTime
                          ? dayjs(TrainingDetail.DateTime)
                          : null
                      }
                      onChange={(data) => AddNewTraining(data, "DateTime")}
                      name="DateTime"
                      className="field-input"
                      format="MM/DD/YYYY  hh:mm"
                      placeholder="MM/DD/YYYY"
                      onKeyDown={(e) => AlterDateValues(e)}
                      showTime={{
                        showSecond: false,
                        use12Hours: true,
                        format: "hh:mm",
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="row">
                    <div className="col-md-8 col-sm-8 mt-2">
                      <div className="field-container">
                        <label className="field-placeholder font-medium">
                          Schedule Link
                        </label>
                        <input
                          type="text"
                          onChange={(e) => AddNewTraining(e)}
                          name="ScheduleLink"
                          className="field-input text-overflow-clip"
                          value={TrainingDetail.ScheduleLink}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-4 col-sm-4">
                      <label>&nbsp;</label>
                      <input
                        type="button"
                        className="btnLinkGreen ClosePopup"
                        onClick={(event) => GenerateLink(event)}
                        value={
                          TrainingDetail.ScheduleLink.length > 1
                            ? "Copy"
                            : "Add"
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container">
                    <label className="field-placeholder font-medium">
                      Training Video Link
                    </label>
                    <input
                      type="text"
                      onChange={(e) => AddNewTraining(e)}
                      name="VideoLink"
                      className="field-input"
                      value={TrainingDetail.VideoLink}
                      maxLength={400}
                    />
                  </div>
                </div>
              </div>
              {props.trainingData && props.trainingData.SEQ_NUM != null && (
                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Status :{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />
                    </label>
                    <select
                      className="field-input"
                      name="status"
                      onChange={(e) => AddNewTraining(e, "status")}
                      value={TrainingDetail.status}
                    >
                      {CLIENT_SEARCH_FILTERS.NEW_PLAN_STATUS_OPTIONS.map(
                        (item) => (
                          <option value={item.value}>{item.label}</option>
                        )
                      )}
                    </select>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="">
                    <label className="field-placeholder label-top-text font-medium">
                      Comments:
                    </label>
                    <textarea
                      rows="2"
                      type="text"
                      cols="10"
                      className="field-input w-100 mt-3"
                      onChange={(e) => AddNewTraining(e)}
                      maxLength={4000}
                      value={TrainingDetail.Comments}
                      name="Comments"
                    />
                  </div>
                </div>
              </div>
              {(sessionStorage.type === "CS" ||
                sessionStorage.type === "CSM" ||
                sessionStorage.type === "M") && (
                  <div className="row text-center">
                    <div className="col-md-12 col-sm-12">
                      <label>&nbsp;</label>
                      <input
                        type="button"
                        className="btnLinkGreen ClosePopup"
                        onClick={() => CreateTraining()}
                        value={
                          props.trainingData?.SEQ_NUM != null
                            ? "Update Training"
                            : "Add Training"
                        }
                      />
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPlan;
